import { Contact } from '@features/contacts/types/contact'
import { Country } from '@modules-deprecated/app/countries/types'

import { SuppliersTableRow } from '../types/suppliersTableRow'

const getSupplierEmail = (contact: Contact): string | null => {
  if (contact.email) {
    return contact.email
  }

  const primaryContactPerson = contact.contactPersons.find((contactPerson) => contactPerson.isPrimary)
  const email = primaryContactPerson?.email ?? contact.contactPersons[0]?.email

  return email || null
}

/**
 * Utility function to handle formatting contacts API responses to the suppliers table data structure.
 */
export const formatContactsToSuppliersTableData = (
  contacts: Contact[],
  countries: Country[] = [],
): SuppliersTableRow[] => {
  const countriesById = new Map(countries.map((country) => [country.id, country.name]))

  return contacts.map<SuppliersTableRow>((contact) => ({
    country: countriesById.get(contact.countryId) ?? null,
    email: getSupplierEmail(contact),
    id: contact.id,
    name: contact.name || null,
    organizationId: contact.organizationId,
    phone: contact.phone || null,
  }))
}
